import { createContext, use } from 'react';

export type AccordionContextValue = {
  type: 'single' | 'multiple';
  collapsible: boolean;
  openValues: string[];
  toggle: (value: string) => void;
};

export type AccordionItemContextValue = {
  value: string;
  isOpen: boolean;
};

export const AccordionContext = createContext<AccordionContextValue | null>(null);
export const AccordionItemContext = createContext<AccordionItemContextValue | null>(null);

export const useAccordion = (): AccordionContextValue => {
  const context = use(AccordionContext);
  if (!context) {
    throw new Error('useAccordion must be used within an <Accordion> component');
  }
  return context;
};

export const useAccordionItem = (): AccordionItemContextValue => {
  const context = use(AccordionItemContext);
  if (!context) {
    throw new Error('useAccordionItem must be used within an <Accordion.Item> component');
  }
  return context;
};
